import { ReactNode } from 'react';
import { AppDialog, DialogButton } from '../common/AppDialog';

/**
 * Shared frame for all Manage tab dialogs. Centralises the themed modal
 * chrome so each dialog only supplies title, body and optional footer
 * extras.
 *
 * Deprecated as a styling provider: it now delegates to the app-wide
 * `AppDialog` shell (src/components/common/AppDialog.tsx). New dialogs
 * should use `AppDialog` directly.
 */
interface ManageDialogFrameProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    footer?: ReactNode;
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
}

export function ManageDialogFrame({
    title,
    isOpen,
    onClose,
    children,
    footer,
    size = 'md',
}: ManageDialogFrameProps) {
    return (
        <AppDialog isOpen={isOpen} onClose={onClose} title={title} size={size} footer={footer}>
            {children}
        </AppDialog>
    );
}

/** Standard footer with a single Close button. */
export function ManageDialogCloseFooter({ onClose, extra }: { onClose: () => void; extra?: ReactNode }) {
    return (
        <>
            {extra}
            <DialogButton variant="ghost" onClick={onClose}>
                Close
            </DialogButton>
        </>
    );
}

/** Accent-styled primary action button used across manage dialogs. */
export function ManageDialogPrimaryButton({
    label,
    onClick,
    isDisabled,
}: {
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
}) {
    return (
        <DialogButton variant="primary" onClick={onClick} isDisabled={isDisabled}>
            {label}
        </DialogButton>
    );
}
